import type { Text } from 'mdast';

import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';

import { asText, readString } from '../utils';

export const status = (node: PMNode): Text | null => asText(readString(node.attrs.text));
